import Library from '../model/Library';
import LibraryCatalog from '../model/LibraryCatalog';
import LibraryBanner from '../model/LibraryBanner';
import VisualTemplate from '../model/VisualTemplate';

export default class LibraryXMLParser {

    parseLibrary(data) {

        var library = new Library();

        var xml = $(data);
        var nodeLibrary = xml.children().first();

        library.libraryId = nodeLibrary.children('ns2\\:libraryId').text();
        library.title = nodeLibrary.children('ns2\\:title').text();
        library.horizontalIndex = nodeLibrary.children('ns2\\:horizontalIndex').text();
        library.verticalIndex = nodeLibrary.children('ns2\\:verticalIndex').text();
        library.compressedResources = nodeLibrary.children('ns2\\:compressedResources').text();
        library.visualTemplate = this.parseVisualTemplate(nodeLibrary.children('ns2\\:visualTemplate'));
        nodeLibrary.children('ns2\\:deviceLanguage').each((i, elem) => {
            library.deviceLanguageList.push($(elem).text());
        });
        library.defaultLanguage = nodeLibrary.children('ns2\\:defaultLanguage').text();
        library.enableAnalytics = nodeLibrary.children('ns2\\:enableAnalytics').text();
        library.analyticsWebId = nodeLibrary.children('ns2\\:analyticsWebId').text();
        library.appUrl = nodeLibrary.children('ns2\\:appUrl').text();
        library.indexSortType = nodeLibrary.children('ns2\\:indexSortType').text();
        library.singleIssueApp = (nodeLibrary.children('ns2\\:singleIssueApp').text() == 'true');
        library.expandPagesXml = (nodeLibrary.children('ns2\\:expandPagesXml').text() == 'true');

        nodeLibrary.children('ns2\\:catalog').each((i, elem) => {
            var libraryCatalog = this.parseLibraryCatalog(elem, library.visualTemplate);
            library.catalogList.push(libraryCatalog);
        });

        return library;
    }

    parseIntelligentFolder(data, visualTemplate) {

        var xml = $(data);
        var nodeIntelligentFolder = xml.children().first();
        return this.parseLibraryCatalog(nodeIntelligentFolder, visualTemplate, '');

    }

    parseVisualTemplate(data) {

        var visualTemplate = new VisualTemplate();

        var nodeVisualTemplate = $(data);

        nodeVisualTemplate.children('ns2\\:horizontalBanner').each((i, elem) => {
            var libraryBanner = this.parseLibraryBanner(elem);
            visualTemplate.horizontalBanner.push(libraryBanner);
        });
        nodeVisualTemplate.children('ns2\\:verticalBanner').each((i, elem) => {
            var libraryBanner = this.parseLibraryBanner(elem);
            visualTemplate.verticalBanner.push(libraryBanner);
        });
        visualTemplate.bannerInterval = nodeVisualTemplate.children('ns2\\:bannerInterval').text();

        nodeVisualTemplate.children('ns2\\:horizontalLibraryInfoImage').each((i, elem) => {
            visualTemplate.horizontalLibraryInfoImages.push($(elem).text());
        });
        nodeVisualTemplate.children('ns2\\:verticalLibraryInfoImage').each((i, elem) => {
            visualTemplate.verticalLibraryInfoImages.push($(elem).text());
        });

        visualTemplate.showExitButton = (nodeVisualTemplate.children('ns2\\:showExitButton').text() == "true");
        visualTemplate.showIndexButton = (nodeVisualTemplate.children('ns2\\:showIndexButton').text() == "true");
        visualTemplate.showPageSlider = (nodeVisualTemplate.children('ns2\\:showPageSlider').text() == "true");
        visualTemplate.showBookmarksButton = (nodeVisualTemplate.children('ns2\\:showBookmarksButton').text() == "true");
        visualTemplate.showCatalogMenu = (nodeVisualTemplate.children('ns2\\:showCatalogMenu').text() == "true");
        visualTemplate.showShareButton = (nodeVisualTemplate.children('ns2\\:showShareButton').text() == "true");
        visualTemplate.showSearchButton = (nodeVisualTemplate.children('ns2\\:showSearchButton').text() == "true");
        visualTemplate.showChangeLanguageButton = (nodeVisualTemplate.children('ns2\\:showChangeLanguageButton').text() == "true");

        visualTemplate.toolbarTintColor = this.parseColor(nodeVisualTemplate.children('ns2\\:toolbarTintColor'), '#000000');
        visualTemplate.toolbarTintSecondaryColor = this.parseColor(nodeVisualTemplate.children('ns2\\:toolbarTintSecondaryColor'), '#00A99D');
        visualTemplate.toolbarBackgroundColor = this.parseColor(nodeVisualTemplate.children('ns2\\:toolbarBackgroundColor'), '#F2F2F2');
        visualTemplate.listCatalogsBackgroundColor = this.parseColor(nodeVisualTemplate.children('ns2\\:listCatalogsBackgroundColor'), '#4D4D4D');
        visualTemplate.catalogTitleColor = this.parseColor(nodeVisualTemplate.children('ns2\\:catalogTitleColor'), '#FFFFFF');
        visualTemplate.catalogDescriptionColor = this.parseColor(nodeVisualTemplate.children('ns2\\:catalogDescriptionColor'), '#B3B3B3');
        visualTemplate.catalogButtonColor = this.parseColor(nodeVisualTemplate.children('ns2\\:catalogButtonColor'), '#FFFFFF');
        visualTemplate.separatorLineColor = this.parseColor(nodeVisualTemplate.children('ns2\\:separatorLineColor'), '#FFFFFF');

        return visualTemplate;
    }

    parseLibraryBanner(data, prefix = 'ns2\\:') {

        var libraryBanner = new LibraryBanner();

        var nodeLibraryBanner = $(data);

        libraryBanner.image = nodeLibraryBanner.children(prefix + 'image').text();
        libraryBanner.url = nodeLibraryBanner.children(prefix + 'url').text();
        libraryBanner.width = nodeLibraryBanner.children(prefix + 'width').text();
        libraryBanner.height = nodeLibraryBanner.children(prefix + 'height').text();
        libraryBanner.language = nodeLibraryBanner.children(prefix + 'language').text();

        return libraryBanner;
    }

    parseLibraryCatalog(data, visualTemplate, prefix = 'ns2\\:') {

        var libraryCatalog = new LibraryCatalog();

        var nodeLibraryCatalog = $(data);

        libraryCatalog.catalogId = nodeLibraryCatalog.children(prefix + 'catalogId').text();
        libraryCatalog.title = nodeLibraryCatalog.children(prefix + 'title').text();
        libraryCatalog.subtitle = nodeLibraryCatalog.children(prefix + 'subtitle').text();
        libraryCatalog.catalogType = nodeLibraryCatalog.children(prefix + 'catalogType').text();
        libraryCatalog.catalogVideoType = nodeLibraryCatalog.children(prefix + 'catalogVideoType').text();
        libraryCatalog.catalogWebType = nodeLibraryCatalog.children(prefix + 'catalogWebType').text();
        libraryCatalog.url = nodeLibraryCatalog.children(prefix + 'url').text();
        libraryCatalog.path = nodeLibraryCatalog.children(prefix + 'path').text();

        nodeLibraryCatalog.children(prefix + 'child').each((i, elem) => {
            var child = this.parseLibraryCatalog(elem, visualTemplate, prefix);
            libraryCatalog.childList.push(child);
            child._parent = libraryCatalog;
        });

        libraryCatalog.fullscreen = nodeLibraryCatalog.children(prefix + 'fullscreen').text();
        libraryCatalog.horizontalImage = nodeLibraryCatalog.children(prefix + 'horizontalImage').text();
        libraryCatalog.verticalImage = nodeLibraryCatalog.children(prefix + 'verticalImage').text();

        nodeLibraryCatalog.children(prefix + 'deviceLanguage').each((i, elem) => {
            libraryCatalog.deviceLanguage.push($(elem).text());
        });

        nodeLibraryCatalog.children(prefix + 'deviceType').each((i, elem) => {
            libraryCatalog.deviceType.push($(elem).text());
        });

        libraryCatalog.publishDate = new Date(nodeLibraryCatalog.children(prefix + 'publishDate').text());
        libraryCatalog.useAsRoot = (nodeLibraryCatalog.children(prefix + 'useAsRoot').text() == "true");

        nodeLibraryCatalog.children(prefix + 'horizontalBanner').each((i, elem) => {
            var libraryBanner = this.parseLibraryBanner(elem, prefix);
            libraryCatalog.horizontalBanner.push(libraryBanner);
        });
        nodeLibraryCatalog.children(prefix + 'verticalBanner').each((i, elem) => {
            var libraryBanner = this.parseLibraryBanner(elem, prefix);
            libraryCatalog.verticalBanner.push(libraryBanner);
        });
        libraryCatalog.bannerInterval = nodeLibraryCatalog.children(prefix + 'bannerInterval').text();

        let showExitButton = nodeLibraryCatalog.children(prefix + 'showExitButton').text();
        libraryCatalog.showExitButton = (showExitButton == '') ? visualTemplate.showExitButton : (showExitButton == "true");

        let showIndexButton = nodeLibraryCatalog.children(prefix + 'showIndexButton').text();
        libraryCatalog.showIndexButton = (showIndexButton == '') ? visualTemplate.showIndexButton : (showIndexButton == "true");

        let showPageSlider = nodeLibraryCatalog.children(prefix + 'showPageSlider').text();
        libraryCatalog.showPageSlider = (showPageSlider == '') ? visualTemplate.showPageSlider : (showPageSlider == "true");

        let showBookmarksButton = nodeLibraryCatalog.children(prefix + 'showBookmarksButton').text();
        libraryCatalog.showBookmarksButton = (showBookmarksButton == '') ? visualTemplate.showBookmarksButton : (showBookmarksButton == "true");

        let showCatalogMenu = nodeLibraryCatalog.children(prefix + 'showCatalogMenu').text();
        libraryCatalog.showCatalogMenu = (showCatalogMenu == '') ? visualTemplate.showCatalogMenu : (showCatalogMenu == "true");

        let showShareButton = nodeLibraryCatalog.children(prefix + 'showShareButton').text();
        libraryCatalog.showShareButton = (showShareButton == '') ? visualTemplate.showShareButton : (showShareButton == "true");

        libraryCatalog.changePageMode = nodeLibraryCatalog.children(prefix + 'changePageMode').text();

        libraryCatalog.intelligentFolderUrl = nodeLibraryCatalog.children(prefix + 'intelligentFolderUrl').text();

        libraryCatalog.backgroundColor = this.parseColor(nodeLibraryCatalog.children(prefix + 'backgroundColor'), '#000000');

        return libraryCatalog;
    }

    parseColor(node, defaultColor = '#FFFFFF') {
        let colorString = node.text();

        if (!colorString || colorString.length == 0)
            return defaultColor;

        if (colorString.charAt(0) == '#')
            colorString = colorString.slice(1);

        var bytes = [];
        while (colorString.length >= 2) {
            bytes.push(parseInt(colorString.slice(0, 2), 16));
            colorString = colorString.slice(2);
        }

        let r = (bytes[0]) ? bytes[0] : 0;
        let g = (bytes[1]) ? bytes[1] : 0;
        let b = (bytes[2]) ? bytes[2] : 0;
        let a = (bytes[3]) ? bytes[3]/255 : 1;

        let color = `rgba(${r},${g},${b},${a})`;

        return color;
    }

}